var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon L"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66153 3.25558C8.62302 2.92402 8.34124 2.66666 7.99935 2.66666C7.63116 2.66666 7.33268 2.96513 7.33268 3.33332V7.33332H3.33268L3.25493 7.33781C2.92338 7.37632 2.66602 7.6581 2.66602 7.99999C2.66602 8.36818 2.96449 8.66666 3.33268 8.66666H7.33268V12.6667L7.33717 12.7444C7.37568 13.076 7.65746 13.3333 7.99935 13.3333C8.36754 13.3333 8.66602 13.0348 8.66602 12.6667V8.66666H12.666L12.7438 8.66217C13.0753 8.62366 13.3327 8.34188 13.3327 7.99999C13.3327 7.6318 13.0342 7.33332 12.666 7.33332H8.66602V3.33332L8.66153 3.25558Z",
    fill: "#059669"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.5b7c1a69eb4d8ef00df1f0d5edabefc4.svg";
export { ForwardRef as ReactComponent };